<div class="container">
  <h1>Import d'une facture éditée par un producteur</h1>

  <div>
    <app-toggle-switch
      [options]="Object.values(EditedInvoicesStatusEnum)"
      [defaultOption]="EditedInvoicesStatusEnum.IMPORT"
      (currentOptionChange)="editedInvoiceStatusChange($event)"
      data-testid="import-toggle"
    ></app-toggle-switch>
  </div>

  @if (showImport) {
    <div class="section-header">
      <div class="information-container">
        <app-report-message
          [backgroundColor]="Color.white"
          [message]="'Importer une ou plusieurs factures éditées. Uniquement les fichier PDF sont acceptés.'"
        ></app-report-message>
      </div>
    </div>

    <div class="import-container">
      <div class="import-container-content">
        <app-file-input
          [extensions]="['application/pdf']"
          (importFile)="importFile($event)"
          [maxFiles]="2"
          [maxFileSize]="6 * 1024 * 1024"
        ></app-file-input>
        @if (this.isImporting) {
          <app-spinner [diameter]="'2rem'"></app-spinner>
        }
      </div>
    </div>
  } @else {
    <div class="container-actions-trash">
      <app-button
        data-testid="delete-button"
        (onclick)="deleteEditedInvoices()"
        [isDisabled]="!risSelection.hasValue()"
      >
        <app-icon [phosphorClass]="'ph-trash'"></app-icon>
      </app-button>
    </div>
    <div class="search-container">
      <div class="text-input-search-container">
        <input
          class="search-input"
          #inputElement
          type="text"
          [(ngModel)]="inputValue"
          placeholder="Recherche par nom de facture"
          (keydown.enter)="getEditedInvoicesSearch(inputElement.value)"
          data-testid="search-input"
        />
        <app-icon
          class="icon-search-input"
          phosphorClass="ph-magnifying-glass"
          [size]="IconSize.medium"
          [iconStyle]="Style.bold"
        ></app-icon>
      </div>
    </div>

    <app-base-table
      id="edited-invoice-table"
      [tableLayoutAuto]="true"
      [source]="editedInvoicesSourceSearch"
      [isLoading]="isLoading"
    >
      <ng-container>
        <tr appRow *appRowHeaders></tr>
        <tr appRow class="readOnly" *appRowCells="let data; let i = index"></tr>
      </ng-container>

      <ng-container *appColumn="'checkbox'">
        <th appColumnHeader appSticky *appTableHeader>
          <app-checkbox
            id="select-all-checkbox"
            [disabled]="!editedInvoicesSourceSearch.length || isLoading"
            (checkedChange)="checkChange($event)"
            [checked]="risSelection.hasValue() && isAllPageSelected()"
            [indeterminate]="risSelection.hasValue() && isCurrentPageSelected()"
            [aria-label]="checkboxLabel()"
          ></app-checkbox>
        </th>
        <td appCell appSticky *appTableCell="let data; let i = index">
          <app-checkbox
            (click)="$event.stopPropagation()"
            (checkedChange)="risSelection.toggle(data?.timestamp)"
            [checked]="risSelection.isSelected(data?.timestamp)"
            [aria-label]="checkboxLabel(data?.timestamp)"
            data-testid="checkbox"
          ></app-checkbox>
        </td>
      </ng-container>

      <ng-container *appColumn="'date'">
        <th appColumnHeader appSticky *appTableHeader>
          <app-column-header name="Date d'import" type="sort" field="timestamp"></app-column-header>
        </th>
        <td data-testid="invoice-date" appCell appSticky *appTableCell="let data">
          <span [innerHTML]="data.timestamp | date: 'dd/MM/yyyy HH:mm'"></span>
        </td>
      </ng-container>

      <ng-container *appColumn="'invoiceName'">
        <th appColumnHeader *appTableHeader>
          <app-column-header name="Facture" type="sort" field="documentId"></app-column-header>
        </th>
        <td appCell *appTableCell="let data">
          <span [innerHTML]="data.documentId"></span>
        </td>
      </ng-container>

      <ng-container *appColumn="'actionsButtons'">
        <th appColumnHeader appSticky="right" *appTableHeader></th>
        <td appCell appSticky="right" *appTableCell="let data; let i = index">
          <div class="actions-edited-invoices">
            <app-button
              [style]="ButtonStyle.Outlined"
              class="comment-button"
              [class.has-comments]="data.comment"
              (onclick)="showCommentDialog(data)"
              [iconOptions]="{ phosphorClass: 'ph-chats-circle', iconStyle: Style.fill, position: ButtonIcon.OnlyIcon }"
              data-testid="comment-button"
            ></app-button>
            <app-button
              [style]="ButtonStyle.Outlined"
              [isLoading]="downloadLoaders[i!]"
              (onclick)="downloadEditedInvoice($event, data, i!)"
              [iconOptions]="{
                phosphorClass: 'ph-download-simple',
                iconStyle: Style.bold,
                position: ButtonIcon.OnlyIcon,
              }"
            ></app-button>
          </div>
        </td>
      </ng-container>
    </app-base-table>
  }
</div>
